module.exports = __webpack_public_path__ + "static/media/Deal_hunter.ccf2c8e4.svg";